import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { OverContainerLoading, PLoadingC } from 'src/components'

import { SuccessStoriesLabels } from 'src/constants'
import { SuccessLabels } from 'src/types'
import { Header } from './TitleSection'
import { InformationData } from './informationData'
import { Helmet } from 'react-helmet'
import { useTranslations } from 'src/provider/LocaleProvider'
import Loading from 'src/components/layout/Main/loading.json'
import Lottie from 'lottie-react'

export interface SectionProps {
    success: any
}

export function DetailedSuccess() {
  const { title } = useParams();
  const t = useTranslations();
  const { ContentSuccessStories } = SuccessStoriesLabels();
  const filteredCard = ContentSuccessStories.find((person) => person.title === title);
  const [card, setCard] = useState<SuccessLabels | null>(filteredCard || null);

    if (!card) {
        return (
            <OverContainerLoading>
                <PLoadingC>
                    <Lottie animationData={Loading} loop={true} />
                </PLoadingC>
            </OverContainerLoading>
        )
    }

    return (
        <>
            <Helmet>
                <title>
                    {card.title}-{t('WorldWile.complement.title')}
                </title>
                <meta
                    name="description"
                    content={'WorldWile.successStories.description'}
                />
            </Helmet>

            <Header success={filteredCard} />
            <InformationData success={filteredCard} />
        </>
    )
}
